var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showButton)?_c('vs-button',{staticClass:"button__back-to-top",attrs:{"type":"gradient","icon-pack":"feather","icon":"icon-arrow-up"},on:{"click":function($event){return _vm.backToTop()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }